import React from "react";
import { CardContent, Typography, Box, Grid } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";

function UnschWorkorderAgeing({ responseFemwoage, responseBemwoage }) {

     const navigate = useNavigate();
  
    return (
        <StyledCard variant="outlined">
            <CardContent>
                <Typography
                    mb={1.5}
                    variant="h5"
                    fontWeight={700}
                    color={"text.primary"}
                >
                    No. of W.O Ageing by Days
                </Typography>

                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{ cursor: "pointer" }}

                    >
                        <StyledCard variant="outlined">
                            <CardContent onClick={() => { navigate("/workorder") }}>
                                <Typography mb={1} color={"text.primary"}>
                                    {"< 30 days"}
                                </Typography>
                                <Typography variant="h1" color={"text.secondary"}>
                                    {Number(responseFemwoage?.lessThan30Days || 0) + Number(responseBemwoage?.lessThan30Days || 0)}
                                </Typography>
                            </CardContent>
                        </StyledCard>
                    </Grid>

                    <Grid item xs={12} sm={6} sx={{ cursor: "pointer" }}
                    >
                        <StyledCard variant="outlined">
                            <CardContent onClick={() => { navigate("/workorder") }}>
                                <Typography mb={1} color={"text.primary"}>
                                    {"> 60 days"}
                                </Typography>
                                <Typography variant="h1" color={"text.secondary"}>
                                    {Number(responseFemwoage?.between61And90Days || 0) + Number(responseBemwoage?.between61And90Days || 0)}
                                </Typography>
                            </CardContent>
                        </StyledCard>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ cursor: "pointer" }}
                    >
                        <StyledCard variant="outlined">
                            <CardContent onClick={() => { navigate("/workorder") }}>
                                <Typography mb={1} color={"text.primary"}>
                                    {"> 30 days"}
                                </Typography>
                                <Typography variant="h1" color={"text.secondary"}>
                                    {Number(responseFemwoage?.between31And60Days || 0) + Number(responseBemwoage?.between31And60Days || 0)}
                                </Typography>
                            </CardContent>
                        </StyledCard>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ cursor: "pointer" }}
                    >
                        <StyledCard variant="outlined">
                            <CardContent onClick={() => { navigate("/workorder") }}>
                                <Typography mb={1} color={"text.primary"}>
                                    {"> 90 days"}
                                </Typography>
                                <Typography variant="h1" color={"text.secondary"}>
                                    {Number(responseFemwoage?.greaterThan90Days || 0) + Number(responseBemwoage?.greaterThan90Days || 0)}
                                </Typography>
                            </CardContent>
                        </StyledCard>
                    </Grid>
                </Grid>

            </CardContent>
        </StyledCard>
    );
}

export default UnschWorkorderAgeing;
